import { Spinner } from 'components/loaders'
import { useParams } from 'react-router-dom'
import { Report } from '../components/report-content/Report'
import { useSavedReport } from '../hooks/useSavedReports'
import { ReportTypeMap, SavedReport } from '../types'

interface Props<RT extends keyof ReportTypeMap> {
  type: RT
}

export const ViewReport = <RT extends keyof ReportTypeMap>({
  type,
}: Props<RT>) => {
  const { reportId } = useParams()
  const { data: savedReport } = useSavedReport(reportId ? Number(reportId) : 0)

  if (reportId !== undefined && savedReport === undefined) {
    return <Spinner />
  }

  return (
    <Report
      savedReport={savedReport as SavedReport<keyof ReportTypeMap>}
      type={type}
    />
  )
}
